export default "__VITE_ASSET__GWoqG5Bi__"